import { get } from "react-hook-form";

export const API_END_POINTS = {
  //params
  quePage: "?page=",
  andPage: "&page=",
  andSize8: "&size=8",
  andSize: "&size=",
  queSize8: "?size=8",
  queLimit8: "?limit=8",
  queSize: "?size=",
  queId: "?category_id",

  //Common
  //auth
  loginRequest: "auth/login",
  forgotPasswordRequest: "auth/forgot-password",
  contactUsRequest: "auth/reach-out-kg",
  triggerEmailForForgotPasswordRequest: "auth/change-password/",
  checkLinkForCreatePasswordRequest: "auth/check-link?slug=",
  logoutRequest: "auth/logout",
  changeNewPasswordRequest: "auth/reset-password",
  getNotificationSettingsRequest: "notification-settings",
  updateNotificationSettingsRequest: "notification-settings/",
  getUserDetailsRequest: "auth/staffById/",

  //USER
  preAsessmentCategoryListRequest_USER: "assessment/list",
  preAsessmentSubCategoryListRequest_USER: "assessment/getSubCategoryById",
  preAsessmentQuestionRequest_USER: "assessment/question",
  preAsessmentOptionsOfQuestionRequest_USER: "assessment/getOption",
  getPendingAssessment_USER: "/auth/getPendingAssessment",
  getPastAssessment_USER: "/auth/getPastAssessment",
  getAllQuestions_USER: "/assessment/question",
  getAssessmentAnswer_USER: "/assessment/answer",
  getRecommendation_USER: "/assessment/recommendation",
  getPreassessmentRecommendation_USER: "/assessment/recommendation",
  getAssessmentJourney: "/assessment/journey",
  getUserCertificationRequest_USER: "assessment/certificate",
  getLatestAssessment_USER: "/auth/getLatestAssessment",
  multiUpload: "/upload/multiple",
  reportDetailsPDF: "/assessment/get_pdf_url",
  addUserFeedback:"/assessment/addUserFeedback",
  viewUserFeedback:"assessment/getUserFeedback",  
  saveIndividualAnswer : "assessment/saveIndividualAnswer",
  getIndividualAnswer : "assessment/getIndividualAnswer",
  saveIndividualInsight : "assessment/saveIndividualinsight",
  getIndividualInsight : "assessment/getIndividualinsight",
  userFinalSubmit : "assessment/userFinalSubmit",
  getPdfData : "assessment/get-all-pdf1",
  userFeedbackModule : "assessment/createOrUpdateUserFeedback",
  getUserFeedbackModule : "assessment/getUserModuleFeedback",
  markRecommendationAsRead : "assessment/mark-recommendation-as-read",
  getRecommendationPercentageCompleted : "assessment/recommendation-read-percentage",
  assessmentPdfUrl : "assessment/insert-assessment-pdf-url",
  // same for user and admin
  getAssessmentReport: "/assessment/report",
  getAssessmentSubCategoryDetails_USER: "assessment/report/module/",
  getNotifications: "notifications",
  //ACCESSOR
  getAssessmentTrackerListRequest_ACCESSOR:
    "assessment/assessmenttrackerlist?limit=8&page=",
  getAssessmentReviewListRequest_ACCESSOR:
    "assessment/assessmentreviewlist?limit=8&page=",
  getCompanyType: "assessment/company_type",
  getUserAnswer: "assessment/getUserAnswer",
  getDashboardBacklogCountsRequest_ACCESSOR:
    "assessment/dashboard_data?period=",
  getAssessmentsSubmittedByCompaniesRequest_ACCESSOR:
    "assessment/dashboard_pre_assessment_data?period=",
  addUserAnswerResearchAndRecommendation:
    "assessment/addUserAnswerResearchAndRecommendation",
  updateUserAnswerResearchAndRecommendation:
    "assessment/updateUserAnswerResearchAndRecommendation",
  getPreviousData: "assessment/getAssessorResearchAndRecommendation",
  getAdditionalInsights: "assessment/getUserInsights",
  addSparePartsLog: "assessment/addSparePartsLog",
  spartParts: "assessment/assessor-spare-parts-logs",
  updateSparePartsLog: "assessment/updateSparePartsLog",
  getPreviewDetail: "assessment/get_preview_page",
  getDropDownData:"assessment/get-ModuleName-Dropdown",
  getProductName : "assessment/product-with-images",
  getStoreAuditData : "assessment/assessor-store-audit",
  addOrUpdateStoreAuditData : "assessment/bulk-upsert-assessor-store-audit",

  //Approver
  getApprovalListRequest_ACCESSOR: "assessment/approval?page=",
  getSparePartsLog: "assessment/get_spare_parts_log",
  assessmentApproveReject: "assessment/assessmentbacklog",
  approverFeedback:"assessment/addApproverFeedback",


  //ADMIN
  getAllStaffsRequest_ADMIN: "auth/getAllStaffs?",
  addStaffsRequest_ADMIN: "auth",
  deleteStaffRequest_ADMIN: "auth/deleteStaff/",
  updateStaffDetailsRequest_ADMIN: "auth/",
  markAsActiveInactiveStaffRequest_ADMIN: "auth/status/",
  fileUploadRequest_ADMIN: "upload/single",
  getCountryListRequest_ADMIN: "assessment/country",
  getAccessorListForAssessmentBLrequest_ADMIN: "assessment/accessor",
  getAllContactUsRequest:'auth/reach-out-kg-list',
  getIndustryListForAssessmentBLrequest_ADMIN: "assessment/industry",
  getAllAssessmentRequest_ADMIN: "assessment/assessmentbacklog?page=",
  getAssessmentDetailsRequest_ADMIN: "assessment/assessmentbacklog/",
  getReportsListRequest_ADMIN: "assessment/completed?page=",
  getDashboardBacklogCountsRequest_ADMIN:
    "assessment/dashboard_admin_data?period=",
  getAgeOfBacklogsRequest_ADMIN: "assessment/backlog_age_admin_data",
  getAssessmentsSubmittedByCompaniesRequest_ADMIN:
    "assessment/dashboard_admin_pre_assessment_data?period=",
  getRecommendationsSubmittedByAssessorsRequest_ADMIN:
    "assessment/dashboard_admin_assessment_assessor_data?period=",
  createAssessmentBLrequest_ADMIN: "assessment/create",
  getRecentAssessmentRequest_ADMIN: "assessment/recent_assessment",
  getRecentSubmissionRequest_ADMIN: "assessment/recent_submission",
  updateAssessmentDueDateRequest_ADMIN: "assessment/edit-assessment/",
  notifyAssessor: "assessment/notify-accessor",
  customerTypeRequest_ADMIN: "assessment/customer_type",
  getCountryCode: "/auth/country_code",
  getCompanyNameListWithDetails : "/assessment/getCompanyDropDownWithValues",
  getUserListFromLastAssessment : "/assessment/getUserListFromLastAssessment",
};
